import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';

/**
 * The portal's own scaffolder field extensions. These used to be passed to the
 * `/create` route as `<ScaffolderFieldExtensions>` children; in the new
 * frontend system they attach themselves to the scaffolder's form fields API,
 * so they only need to be installed as extensions.
 *
 * The `name` is what a template refers to in `ui:field`, so it has to keep
 * matching the names the templates already use.
 */

export const clientPickerFormField = FormFieldBlueprint.make({
  name: 'client-picker',
  params: {
    field: () =>
      import('./ClientPicker/ClientPicker').then(m =>
        createFormField({
          name: 'ClientPicker',
          component: m.ClientPicker,
        }),
      ),
  },
});

export const terraformRemoteStatePickerFormField = FormFieldBlueprint.make({
  name: 'terraform-remote-state-picker',
  params: {
    field: () =>
      import('./TerraformRemoteStatePicker/TerraformRemoteStatePicker').then(
        m =>
          createFormField({
            name: 'TerraformRemoteStatePicker',
            component: m.TerraformRemoteStatePicker,
            schema: m.terraformRemoteStatePickerSchema,
          }),
      ),
  },
});

export const projectCreatorFormField = FormFieldBlueprint.make({
  name: 'project-creator',
  params: {
    field: () =>
      import('./ProjectCreator/ProjectCreator').then(m =>
        createFormField({
          name: 'ClearisticProjectCreator',
          component: m.ProjectCreator,
        }),
      ),
  },
});

export const formFieldExtensions = [
  clientPickerFormField,
  terraformRemoteStatePickerFormField,
  projectCreatorFormField,
];
